<template>
  <PlainTable :sourceList="itemArray" :useExcel="true" ref="contentTable">
    <template #header>
      <caption>
        <span class="blind">{{title}}</span>
      </caption>
      <colgroup>
        <col width="300px"/>
      </colgroup>
      <thead class="table_list_head table_list_head_line">
        <tr>
          <th rowspan="2">{{divName}}</th>
          <th rowspan="2">대상자수</th>
          <th colspan="2">마음체조</th>
          <th colspan="2">좋은생각</th>
        </tr>
        <tr>
          <th>호출건수</th>
          <th>이용자수</th>
          <th>호출건수</th>
          <th>이용자수</th>
        </tr>
      </thead>
    </template>
    <template #row="{rowData}">
      <TableRow
        :item="rowData.item"
        :rcpCount="rowData.rcpCount"
        :healthUseMind="rowData[`${listKey}HealthUseMind`]"
        :healthUseGood="rowData[`${listKey}HealthUseGood`]"
      />
    </template>
  </PlainTable>
</template>

<script>
import TableRow from "./ItemTable.row";

export default {
  components: { TableRow },
  props: {
    title: String,
    listKey: String,
    itemArray: Array,
    divName: String
  }
};
</script>